import React from "react";
import { Alert, Button, Modal, ModalBody, ModalFooter, ModalHeader, Table } from "reactstrap";

export type PlantillaContextForm = {
  sucursalId: string;
  depositoId: string;
  puntoId: string;
};

export type PlantillaResumen = {
  id: string;
  nombre: string;
  descripcion: string | null;
  actualizadoEn: string;
    items: {
      productoCodigo?: string | null;
      productoDescripcion?: string | null;
      unidadDescripcion?: string | null;
      unidadId?: number | null;
      depositoSalidaId?: number | null;
      depositoDestinoId?: number | null;
      grupo?: string | null;
      grupoId?: number | null;
      orden?: number | null;
    }[];
};

interface MovimientoPlantillasModalProps {
  visible: boolean;
  contextoDescripcion: string;
  plantillas: PlantillaResumen[];
  cargando: boolean;
  error: string | null;
  mensaje: string | null;
  onBuscar: (options?: { mostrarError?: boolean }) => void;
  onCerrar: () => void;
  onAbrirCrear: () => void;
  onSeleccionar: (plantilla: PlantillaResumen) => void;
  onAccionPendiente: (accion: string) => void;
}

const MovimientoPlantillasModal: React.FC<MovimientoPlantillasModalProps> = ({
  visible,
  contextoDescripcion,
  plantillas,
  cargando,
  error,
  mensaje,
  onBuscar,
  onCerrar,
  onAbrirCrear,
  onSeleccionar,
  onAccionPendiente,
}) => (
  <Modal isOpen={visible} toggle={onCerrar} size="lg">
    <ModalHeader toggle={onCerrar}>Plantillas disponibles</ModalHeader>
    <ModalBody>
      <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between mb-3">
        <p className="text-muted small mb-0">{contextoDescripcion}</p>
          <div className="d-flex flex-wrap gap-2">
            <Button color="soft-primary" onClick={() => onBuscar({ mostrarError: false })} disabled={cargando}>
            <i className="ri-refresh-line align-middle me-1" />
            Actualizar
          </Button>
          <Button color="soft-success" onClick={onAbrirCrear}>
            <i className="ri-add-circle-line align-middle me-1" />
            Crear plantilla
          </Button>
        </div>
      </div>
      {error && <Alert color="danger">{error}</Alert>}
      {mensaje && !error && <Alert color="success">{mensaje}</Alert>}
      <div className="table-responsive">
        <Table className="align-middle mb-0">
          <thead className="table-light">
            <tr>
              <th>Nombre</th>
              <th>Descripción</th>
              <th>Actualizado</th>
              <th>Items</th>
              <th style={{ width: "240px" }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {cargando ? (
              <tr>
                <td colSpan={5} className="text-center text-muted py-4">
                  Cargando plantillas...
                </td>
              </tr>
            ) : plantillas.length === 0 ? (
              <tr>
                <td colSpan={5} className="text-center text-muted py-4">
                  No encontramos plantillas guardadas para esta combinación. Podés crear una usando el botón
                  "Crear plantilla".
                </td>
              </tr>
            ) : (
              plantillas.map((plantilla) => (
                <tr key={plantilla.id}>
                  <td>{plantilla.nombre}</td>
                  <td>{plantilla.descripcion || "-"}</td>
                  <td>{new Date(plantilla.actualizadoEn).toLocaleString()}</td>
                  <td>{plantilla.items.length}</td>
                  <td>
                    <div className="d-flex flex-wrap gap-2">
                      <Button color="soft-primary" size="sm" onClick={() => onSeleccionar(plantilla)}>
                        <i className="ri-file-copy-2-line align-middle me-1" />
                        Seleccionar
                      </Button>
                      <Button color="soft-info" size="sm" onClick={() => onAccionPendiente("editar")}>
                        <i className="ri-edit-line align-middle me-1" />
                        Editar
                      </Button>
                      <Button color="soft-warning" size="sm" onClick={() => onAccionPendiente("duplicar")}>
                        <i className="ri-file-copy-line align-middle me-1" />
                        Duplicar
                      </Button>
                      <Button color="soft-danger" size="sm" onClick={() => onAccionPendiente("anular")}>
                        <i className="ri-close-circle-line align-middle me-1" />
                        Anular
                      </Button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
    </ModalBody>
    <ModalFooter>
      <Button color="secondary" onClick={onCerrar}>
        Cerrar
      </Button>
    </ModalFooter>
  </Modal>
);

export default MovimientoPlantillasModal;
